module.exports = __webpack_public_path__ + "static/TT1444_TW-MKM02a-5c17ecd57ad808bd07aa22165386c385.png";